import {ComponentUtils, HeadFilterOperator, SwList, SwTableDropdown} from 'simplifyworks-core-ui';
import React from 'react';
import i18n from 'i18next';
import {FormControl, FormGroup, InputGroup, OverlayTrigger, Tooltip} from 'react-bootstrap';
import isEqual from 'lodash/isEqual';
import FilterOperatorMenuItem from 'simplifyworks-core-ui/dist/components/List/HeadFilter/FilterOperatorMenuItem';

class SwListCustomOverride extends SwList.Custom {

	renderColumnFilter(filterUsed) {
		const disabledByOtherComps = this.props.tableProps.headFilterDisabled;
		const disabledTooltipKey = 'core-disabled-by-other-filter-components';
		return this.props.filterable &&
			<FormGroup>
				<InputGroup style={{ position: 'static' }}>
					<OverlayTrigger placement='bottom' overlay={this.getTooltip()}>
						<SwTableDropdown
							className='input-group-btn input-group-btn-sm'
							title={this.state.headFilterOperator.icon}
							size='sm'
							noCaret
							disabled={disabledByOtherComps}
							menu={
								[
									HeadFilterOperator.LIKE_UNACCENT
								].map(
									(operator, index) => <FilterOperatorMenuItem key={index}
										operator={operator}
										onItemClick={this.changeFilterOperator.bind(this)}
										activeItem={this.state.headFilterOperator} />
								)}
							id={this.props.property} />
					</OverlayTrigger>
					<OverlayTrigger placement='bottom' overlay={<Tooltip id='core-table-head-filter-tooltip'>{i18n.t(disabledByOtherComps ? disabledTooltipKey : 'core-table-head-filter-tooltip')}</Tooltip>}>
						<FormControl
							type='text'
							size='small'
							onKeyDown={this.onHeadFilterKeyDown.bind(this)}
							onBlur={(event) => {
								const value = ComponentUtils.getValueOrNull(event.target.value);
								this.props.tableProps.headFilterValueChanged(this.props.property, this.state.headFilterOperator.operator, value);
							}}
							onChange={(event) => this.setState({ headFilterValue: event.target.value })}
							value={this.state.headFilterValue || ''}
							disabled={this.state.headFilterDisabled || disabledByOtherComps}
						/>
					</OverlayTrigger>
					{this.isClearButtonVisible(filterUsed) && !disabledByOtherComps
						? this.renderHeadFilterClearButton(() => {
							const setToDefaultOperator = isEqual(HeadFilterOperator.IS_NULL, this.state.headFilterOperator) || isEqual(HeadFilterOperator.IS_NOT_NULL, this.state.headFilterOperator);
							const operator = setToDefaultOperator ? null : this.state.headFilterOperator.operator;
							this.props.tableProps.headFilterValueChanged(this.props.property, operator, null);
							this.props.tableProps.headFilterChanged(this.props.property, operator, null);
						})
						: null}
				</InputGroup>
			</FormGroup >;
	}

	isClearButtonVisible(filterUsed) {
		return filterUsed;
	}

	onHeadFilterKeyDown(event) {
		if (event.keyCode === 13) {
			const value = ComponentUtils.getValueOrNull(event.target.value);
			this.props.tableProps.headFilterChanged(this.props.property, this.state.headFilterOperator.operator, value);
		}
	}

}

export default SwListCustomOverride;
